module.exports = __webpack_public_path__ + "img/Jc.95e63975.png";